import {ILowFareService} from "./low-fare.service.interface";
import {Station} from "../stations/station.service.interface";
import {ServiceBase} from "../service-base";
import {IOneWayLowFareReader} from "./low-fare-readers/low-fare-reader.interface";
import {VoidOneWayLowFareReader} from "./low-fare-readers/void-low-fare-reader";
import {OneWayLowFareReader} from "./low-fare-readers/one-way-low-fare-reader";
import {NullableNumber, NullableString} from "../../types/nullable-types";
import {IFlightScheduleFilter} from "../flight-search/flights-schedule/flight-schedule-filter.interface";
import {IServiceFactory} from "../service-factory.interface";
import {LowFaresCache} from "./low-fares-cache";
import {IDotRezUserSession} from "../dot-rez-api/session/user-session/dot-rez-user.session.interface";
import {IDotRezAvailabilityLowFarePassengers} from "../dot-rez-api/data-contracts/requests/lowfare-search.request";

export class LowFareService extends ServiceBase implements ILowFareService {

    constructor(services: IServiceFactory) {
        super(services);
        this._cache = new LowFaresCache(this.services);
    }

    private readonly _cache: LowFaresCache;

    createLowFareReader(originStation: Station,
                        destinationStation: Station,
                        getDotRezSession: () => Promise<IDotRezUserSession>,
                        getClassOfServices: () => Promise<string[]>,
                        getAnonymousAgentName: () => NullableString,
                        getMinPriceAmount: () => NullableNumber,
                        getCurrency: () => string,
                        scheduleFilter: IFlightScheduleFilter,
                        passengersCount: () => IDotRezAvailabilityLowFarePassengers): IOneWayLowFareReader {

        if (!this.services.configuration.data.marketing.enableLowFare || this.services.configuration.data.hidePricesInSearchMask) {
            return new VoidOneWayLowFareReader();
        }

        return new OneWayLowFareReader(
            originStation,
            destinationStation,
            this._cache,
            getDotRezSession,
            getClassOfServices,
            getAnonymousAgentName,
            getMinPriceAmount,
            getCurrency,
            scheduleFilter,
            this.services,
            passengersCount);
    }
}


